import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h1", { class: "page-name" }, "定型文マスタ保守", -1)
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "p-field p-grid" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "title",
  class: "p-col-12 p-mb-2 p-md-2 p-mb-0"
}, " 定型文 ", -1)
const _hoisted_7 = { class: "p-col-10 p-mb-10" }
const _hoisted_8 = { class: "p-d-flex p-jc-end" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "table-header" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 編集 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OJ7061F = _resolveComponent("OJ7061F")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_OJ7061F, { ref: "OJ7061F" }, null, 512),
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.mRefTEKEBU,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mRefTEKEBU = $event)),
                type: "text",
                class: "p-inputtext p-component",
                style: {"width":"50%"}
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            label: "クリア",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fncClearButton())),
            class: "p-button",
            style: {"margin-right":"10px"}
          }),
          _createVNode(_component_Button, {
            label: "検索",
            onClick: _ctx.fncGetList,
            class: "p-button"
          }, null, 8, ["onClick"])
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_DataTable, {
          value: _ctx.mDgList,
          dataKey: "TEKEKY",
          class: "p-datatable-striped p-datatable-gridlines p-datatable-sm p-datatable-responsive p-datatable-customers",
          loading: _ctx.loadingFlg,
          paginator: true,
          rows: 30,
          scrollable: true,
          paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
          currentPageReportTemplate: "{totalRecords}件中 {first}件〜{last}件を表示"
        }, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_Button, {
                label: "新規",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fncShowShosai(0))),
                class: "p-button normal-button p-mr-2 p-mb*2"
              })
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "DSPJUN",
              header: "表示順",
              headerStyle: "width: 50px;",
              bodyStyle: "text-align: left;width: 50px;",
              sortable: true
            }),
            _createVNode(_component_Column, {
              field: "TEKEBU",
              header: "定型文",
              headerStyle: "width: 250px;",
              bodyStyle: "text-align: left;width: 250px; white-space: pre-wrap;",
              sortable: true
            }),
            _createVNode(_component_Column, {
              header: "",
              headerStyle: "width: 100px;",
              headerClass: "frozen-column",
              bodyStyle: "text-align: center;width: 100px;",
              bodyClass: "frozen-column"
            }, {
              body: _withCtx((row) => [
                _createVNode(_component_Button, {
                  onClick: ($event: any) => (_ctx.fncShowShosai(row.data.TEKEKY)),
                  type: "button",
                  class: "p-button-success"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ])
    ])
  ], 64))
}